const flights = {
  flight: "Vol", // translated
  flights: "Vols", // translated
  originDepartureDate: "Départ", // translated
  destinationDepartureDate: "Retour", // translated
  outbound: "Sortant", // translated
  inbound: "Entrant", // translated
  travelTime: "Temps de voyage", // translated
  selected: "choisi", // translated
  select: "sélectionner", // translated
  airline: "Compagnie aérienne", // translated
  directFlight: "Vol direct", // translated
  baggage: "bagages", // translated
  stops: "Arrêts", // translated
  nonStop: "Non stop", // translated
  oneStopMax: "Un arrêt maximum", // translated
  twoStopsMax: "Deux arrêts maximum", // translated
  anyStops: "Avec tous les arrêts", // translated
  smallBaggage: "Petit bagage", // translated
  bigBaggage: "Gros bagages", // translated
  smallAndBigBaggage: "Petits et gros bagages", // translated
  outboundStops: "Arrêts aller", // translated
  inboundStops: "Arrêts entrants", // translated
  selectAirline: "Sélectionnez la compagnie aérienne", // translated
  baggageOption: "Option bagages", // translated
  outboundDepartureAfter: "Départ aller après", // translated
  outboundArrivalAfter: "Arrivée sortante après", // translated
  inboundDepartureAfter: "Départ entrant après", // translated
  inboundArrivalTimeAfter: "Arrivée entrante après", // translated
  flightClass: "Classe de vol", // translated
  outboundDepAfter: "Départ après", // translated
  outboundArrivalAfrer: "Départ arrivée après", // translated
  inboundDepAfter: "En départ après", // translated
  inboundArrivalAfter: "À l'arrivée après", // translated
  airlines: "Compagnie(s) aérienne(s)", // translated
  lessThan: "Moins que", // translated
  layover: "Halte", // translated
  duration: "Durée", // translated
  economy: "Économie", // translated
  business: "Entreprise", // translated
  with: "Avec", // translated
  without: "Sans", // translated
  twoOrMore: "Deux ou plus", // translated
  departure: "Départ", // translated
  return: "Retour", // translated
  submit: "Soumettre", // translated
  priceLessThan: "Prix inférieur à", // translated
  durationLessThan: "Durée inférieure à", // translated
  layoverLessThan: "Escale inférieure à", // translated
  noLayover: "Pas d'escale", // translated
  durationLowestFirst: "Durée (la plus basse en premier)", // translated
  durationHighestFirst: "Durée (la plus élevée en premier)", // translated
  idType: "Type d'identification", // translated
  idPassportCode: "Code d'identité/passeport", // translated
  expirationDate: "Date d'expiration", // translated
  frequentFlyerNumber: "Numéro de voyageur fréquent", // translated
  frequentFlyerAirline: "Compagnie aérienne de fidélisation", // translated
  dateOfBirth: "Date de naissance", // translated
  infant: "Nourrisson", // translated
  phone: "Téléphone", // translated
  title: "Titre", // translated
  noLuggageIncluded: "Aucun bagage inclus", // translated
  includesLuggage: "Comprend les bagages", // translated
  outboundFlight: "Vol aller", // translated
  inboundFlight: "Vol entrant", // translated
  flightNumber: "Numéro de vol", // translated
  flightNumbers: "Numéros de vol", // translated
  cabinClassType: "Type de classe de cabine", // translated
  aircraftType: "Type d'avion", // translated
  airlineName: "Nom de la compagnie aérienne", // translated
  no: "Non", // translated
  yes: "Oui", // translated
  anyFlights: "Tous les vols", // translated
  oneStop: "Un arrêt", // translated
  direct: "Direct", // translated
  directFlights: "Vols directs", // translated
  all: "Tous", // translated
  first: "D'abord", // translated
  premiumEconomy: "Prém. Économie", // translated
  withBaggageOnly: "Avec bagages uniquement", // translated
  oneWay: "Sens Unique", // translated
  roundTrip: "Aller-retour", // translated
  withBaggage: "Avec bagages", // translated
  noBaggage: "Pas de bagage", // translated
  requiredFields: "Champs obligatoires", // translated
  nonRequiredFields: "Champs non obligatoires", // translated
  cabinClass: "Classe cabine", // translated
  brandName: "Marque", // translated
  performNewSearch: "Effectuer une nouvelle recherche", // translated
  outboundDeparture: "Départ aller", // translated
  inboundDeparture: "Départ entrant", // translated
  created: "Créé", // translated
  freeCancellationAvailable: "Annulation gratuite disponible", // translated
  freeCancellationDeadline: "Délai d’annulation gratuit", // translated
  externalReference: "Référence externe", // translated
  outboundflightNumber: "Numéro de vol aller", // translated
  inboundflightNumber: "Numéro de vol entrant", // translated
  arrival: "Arrivée", // translated
};

export default flights;
